import React, { useState } from 'react';

const SearchHistory = ({ searchHistory, onSearchJobSeeker }) => {
  const [searchForm, setSearchForm] = useState({ email: '', reason: '' });
  const [jobSeekerDetails, setJobSeekerDetails] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSearch = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setJobSeekerDetails(null);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}admin/admin/search-jobseeker`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify(searchForm)
      });
      const data = await response.json();
      if (response.ok) {
        setJobSeekerDetails(data.jobSeeker);
        setSuccess(data.message);
        setSearchForm({ email: '', reason: '' });
        onSearchJobSeeker(); // Trigger parent to refresh searchHistory
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError('Server error while searching jobseeker');
    }
  };

  return (
    <div className="p-6 bg-white text-gray-800">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Search JobSeeker</h2>
      <form onSubmit={handleSearch} className="mb-6 bg-gray-100 p-6 rounded-lg shadow-md">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <input
            type="email"
            placeholder="JobSeeker Email"
            value={searchForm.email}
            onChange={(e) => setSearchForm({ ...searchForm, email: e.target.value })}
            className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
            required
          />
          <input
            type="text"
            placeholder="Reason (required if not your jobseeker)"
            value={searchForm.reason}
            onChange={(e) => setSearchForm({ ...searchForm, reason: e.target.value })}
            className="p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-orange-500"
          />
        </div>
        <button
          type="submit"
          className="bg-orange-500 text-white px-4 py-2 rounded hover:bg-orange-600 transition-colors"
        >
          Search
        </button>
        {success && <p className="mt-2 text-green-600">{success}</p>}
        {error && <p className="mt-2 text-red-600">{error}</p>}
      </form>

      {jobSeekerDetails && (
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-gray-800 mb-2">JobSeeker Details</h3>
          <div className="bg-gray-100 p-4 rounded-lg shadow-md">
            <p><strong>Name:</strong> {jobSeekerDetails.firstName} {jobSeekerDetails.lastName}</p>
            <p><strong>Email:</strong> {jobSeekerDetails.email}</p>
            <p><strong>Assigned Admin:</strong> {jobSeekerDetails.createdBy?.fullName} ({jobSeekerDetails.createdBy?.email})</p>
            <p><strong>Jobs Assigned:</strong> {jobSeekerDetails.jobAssignments?.length || 0}</p>
          </div>
        </div>
      )}

      <h3 className="text-xl font-semibold text-gray-800 mb-2">Search History</h3>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gray-200">
              <th className="p-2 text-left text-gray-700">JobSeeker Email</th>
              <th className="p-2 text-left text-gray-700">Name</th>
              <th className="p-2 text-left text-gray-700">Own JobSeeker</th>
              <th className="p-2 text-left text-gray-700">Reason</th>
              <th className="p-2 text-left text-gray-700">Searched At</th>
            </tr>
          </thead>
          <tbody>
            {searchHistory?.map(search => (
              <tr
                key={search._id}
                className={`border-b border-gray-200 ${search.isOwnJobSeeker ? '' : 'bg-red-100'}`}
              >
                <td className="p-2">{search.jobSeekerEmail}</td>
                <td className="p-2">{search.jobSeekerId ? `${search.jobSeekerId.firstName} ${search.jobSeekerId.lastName}` : '-'}</td>
                <td className="p-2">{search.isOwnJobSeeker ? 'Yes' : 'No'}</td>
                <td className="p-2">{search.reason || '-'}</td>
                <td className="p-2">{new Date(search.searchedAt).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {searchHistory?.length === 0 && (
          <p className="text-gray-600 mt-2">No search history available.</p>
        )}
      </div>
    </div>
  );
};

export default SearchHistory;